/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageReviewGroupModel {
        public reviewGroups: Wars.Domain.Model.Reviews.ReviewGroup[];
        public currentReviewGroup: Wars.Domain.Model.Reviews.ReviewGroup;
        public systemCodeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        
        constructor(
            private reviewGroupService: services.ReviewGroupService,
            private deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService)
        {
            systemLevelService.getSystemLevelReviewGroups().then(
                (systemLevel) => {
                    this.reviewGroups = systemLevel.myReviewGroups;
                    this.systemCodeGroups = systemLevel.myCodeGroups;
                });
        }

        public addReviewGroup(): void {
            var newReviewGroup = this.reviewGroupService.createNewReviewGroup();
            this.reviewGroups.push(newReviewGroup);
            this.currentReviewGroup = newReviewGroup;
        }

        public editReviewGroup(reviewGroup: Wars.Domain.Model.Reviews.ReviewGroup) {
            this.currentReviewGroup = reviewGroup;
        }

        public removeReviewGroup(reviewGroup: Wars.Domain.Model.Reviews.ReviewGroup) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ReviewGroup",
                reviewGroup.id,
                "Review Group",
                () => this.reviewGroups.remove(reviewGroup));
        }

        public save(): void {
            this.reviewGroupService.saveAllChanges();
        }

        public close(): void {
            this.currentReviewGroup = undefined;
        }
    }
}